import styled from "styled-components"
import Star1 from '@/img/activity50/star1@2x.png'
import Star2 from '@/img/activity22/star2@2x.png'
// import timeTick from '@/img/members0604/b.png'
import timeTick from '@/img/activity50/btn1.png'

export const Content = styled.div`
  min-height: 100vh;
  position: relative;
  padding: 44px 0 115px;
 
  z-index: 0;
  box-sizing: border-box;
  .hidden{
    display:none;
  }
  .title-box{
    text-align: center;
    .title {
      text-align: center;
      color: white;
      font-size: 20px;
      line-height: 58px;
      position: relative;
      display: inline-block;
      &::before,  &::after{
        content: '';
        display: block;
        width: 20px;
        height:14px;
        position: absolute;
        top: 50%;
        margin-top: -10px;
        // background: white;
        background-size: 100%;
      } 
      &::before{
        left: -30px;
        background-image: url(${Star2});
        
      }
      &::after{
        right: -30px;
        background-image: url(${Star1});
      }
    }
  }
  .title-box2{
    text-align: center;
    .title {
      text-align: center;
      color: white;
      font-size: 16px;
      line-height: 58px;
      position: relative;
      display: inline-block;
     
    }
  }
  .title-box+.message {
    text-align:center;
    margin-top: -12px;
    padding-top: 5px;
    letter-spacing: 2px;
    padding-bottom: 7px;
    font-size: 12px;
    font-weight: 300;
    color: rgba(255,208,218);
  }
  .logo{
    position: absolute;
    width:21vw;
    top:70px;
    left:20px;
    z-index: 10;
  }
  .content {
    position: relative;
    z-index: 0;
   
  }

  .contentfooter {
    position: fixed;
    width: 100%;
    bottom: 0px;
    z-index: 999;
    background-color:#F1385B;
    padding-bottom: 28px;
    // @supports (bottom: env(safe-area-inset-bottom)){
    //    padding-bottom: env(safe-area-inset-bottom)!important;
    //   //  padding-bottom: max(env(safe-area-inset-bottom, 28px)!important;
    // }
    
     @supports (bottom: constant(safe-area-inset-bottom)){
        padding-bottom: constant(safe-area-inset-bottom)!important;
    }
  }
  .member-img {
    width: 100%;
    vertical-align: middle;
    font-size:0;
  }
  .btn {
    margin: 50px;
    background-image: url(${timeTick});
    background-size: 100% 100%;
    height: 40px;
    font-size: 16px;
    font-wight: 700px;
    color: white;
    text-align: center;
    line-height: 40px;
  }
  .flex {
    margin: 0 12px;
    margin-top: -3vw;
    margin-top: -3vw;
    display: flex;
    background: #C71A3D;
   
    color: rgba(255,255,255,.8);
    line-height: 28px;
    font-weight: 600;
    font-size: 13px;
    border-radius: 14px;
    justify-content: space-between;
    height: 40px;

    .flex-item {
      line-height: 40px;
      font-weight: 300;
      width: 105px;
      text-align: center;
      max-width: 105px;
      &.block {
        font-weight: 600;
        // width: 105px;
        // height: 28px;
        color:#F1385B;
        background: #FFFFFF;
    
        border-radius: 14px;
       
      } 
    }

  }

  // .block {
  //   font-weight: 600;
  //   width: 105px;
  //   height: 28px;
  //   color:#F1385B;
  //   background: #FFFFFF;

  //   border-radius: 14px;
   
  // }
`

export const Descp = styled.p`
  font-size: 14px;
  color: #511e21;
  line-height: 17px;
  text-align: justify;
  .text-l {
    text-align: left;
  }
`

export  const DescIcon = styled.img`
    width: 22px;
    position: absolute;
    top: 238px;
    right: 0;
`






// WEBPACK FOOTER //
// ./src/views/activity_50/style.js